export default __webpack_public_path__ + "static/cellStyling-3235088d0b03b3a8e8384c9d392a71ac.gif";